export const InvoiceReceipt = (destinationLang) => {
  return [
    {
      FormKey: "invoice-receipt-label-select-months",
      Key: "ماه",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "invoice-receipt-label-select-year",
      Key: "سال",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "invoice-receipt-label-receipt-type",
      Key: "نوع فیش",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "invoice-receipt-label-get-paycheck",
      Key: "دریافت فیش",
      DistinitationLanguage: destinationLang,
    },
  ];
};
